import React, { useState, useEffect } from 'react'
import Layout from '../../../components/Admin/Layout'
import Subtitle from '../../../components/Admin/Subtitle'
import Loading from '../../../components/shared/Loading'
import MessageModal from '../../../components/shared/MessageModal'
import Item from '../../../components/Admin/Item'
import AdminService from '../../../services/AdminServices'
import './Profiles.scss'
import ModalForm from '../../../components/Admin/ModalForm'
import SimpleModal from '../../../components/shared/MessageModal'
import helperAdmin from '../../../utils/helperAdmin'

function Profiles() {
  const [data, setData] = useState([])
  const [modalWarning, setModalWarning] = useState(false)
  const [loading, setLoading] = useState(false)
  const [openModalForm, setModalForm] = useState(false)
  const [openMessage, setOpenMessage] = useState(false);
  const [error, setError] = useState({});
  const [profile, setProfile] = useState({
    name: '',
    description: '',
    title: ''
  })

  const clearProfile = () => {
    setProfile({
      id: '',
      name: '',
      description: '',
      title: ''
    })
    setError({})
  }

  async function fetchData() {
    try {
      setLoading(true)
      const roles = await AdminService.getProfiles()
      console.log(roles);
      setData(formatData(roles))
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [])

  const formatData = data => {
    return data.map(d => {
      // d.name = d.title
      return d
    })
  }

  const renderItems = () => {
    return data.map(d => (
      <Item
        onClickEdit={() => { setModalForm(true); setProfile(d) }}
        onClickDelete={() => { setOpenMessage(true); setProfile(d) }}
        details={<Detail description={d.description} />} >
        <div className='profile-item'>
          <p>{d.title}</p>
        </div>
      </Item>
    ))
  }

  const Detail = ({ description }) => {
    return (
      <div className='profile-detail-container'>
        <p>{description}</p>
      </div>
    )
  }

  const handleChange = (evt, name) => {
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    console.log(value, key);
    setProfile({ ...profile, [key]: value });

    let newError = { ...error }
    if (newError[key]) newError = helperAdmin.removeKey(key, newError);
    setError(newError)
  }

  const handleCreateProfile = async () => {
    // Validar si campos vacios
    console.log(profile)
    const newError = helperAdmin.validateProfile(profile);
    setError(newError);
    // RETORNAR para parar la ejecucion
    if (Object.entries(newError).length !== 0 && newError.constructor === Object) return;
    try {
      setLoading(true)
      if(profile.id) await AdminService.updateProfile(profile.id, profile.title, profile.description, profile.name);
      else  await AdminService.createProfile(profile.title, profile.description, profile.name)
      setLoading(false)
      clearProfile()
      setModalForm(false)
      fetchData()
    } catch (error) {
      setLoading(false)
      setModalWarning(true)
    }
  }

  const handleDelete = async () => {
    // const profiles = data.filter(d => d.id !== profile.id);
    // setData(profiles);
    // clearProfile()
    // setOpenMessage(false);
    try {
      setLoading(true)
      await AdminService.deleteProfile(profile.id)
      setLoading(false)
      clearProfile()
      setOpenMessage(false)
      fetchData()
    } catch (e) {
      setLoading(false)
      setModalWarning(true)
    }
  }

  return (
    <Layout>
      <MessageModal visible={modalWarning} closeModal={() => setModalWarning(false)} message='No se pudo conectar al servicio. Revise su conexión' type={1} />
      <ModalForm
        title='Perfil'
        visible={openModalForm}
        closeModal={() => { setModalForm(false); clearProfile() }}
        onClickBtn1={() => { setModalForm(false); clearProfile() }}
        onClickBtn2={handleCreateProfile}
        updating={profile.id}
        roleName={profile.name}
        titleRole={profile.title}
        description={profile.description}
        onChange={handleChange}
        error={error}
      />
      <SimpleModal
        visible={openMessage}
        closeModal={() => { setOpenMessage(false); clearProfile() }}
        message='¿Desea eliminar el perfil seleccionado?'
        type={3}
        txtBtn1='Cancelar'
        txtBtn2='Eliminar'
        onClickBtn1={() => { setOpenMessage(false); clearProfile() }}
        onClickBtn2={handleDelete}
      />
      <Loading visible={loading} />
      <div className='profile-container'>
        <Subtitle
          text='Perfiles'
          onClick={() => { setModalForm(true) }}
        />
        <div className='profile-items'>
          {renderItems()}
        </div>
      </div>
    </Layout>
  )
}

export default Profiles
